// test826
(826 && 0);
